import React from "react";
import ReactDOM from "react-dom";
import { Tweet } from "react-twitter-widgets";
import InstagramEmbed from "react-instagram-embed";

const rehydrateComponents = (container, component, componentName) => {
  const nodes = Array.from(container.querySelectorAll(`[data-react-class=${componentName}]`));
  nodes.forEach((node) => {
    const props = JSON.parse(node.dataset.reactProps);
    const tweetComponent = React.createElement(component, props);
    ReactDOM.render(tweetComponent, node);
  });
};

// Rehydrate dynamic content in a given content body
//
// Usage:
//
// import initializeContentBody from "lib/content_body";
//
// const node = document.querySelector("div.something");
// initializeContentBody(node);
//
export default (node) => {
  rehydrateComponents(node, Tweet, "Tweet");
  rehydrateComponents(node, InstagramEmbed, "InstagramEmbed");
};
